"use strict";
(function (global) {

  /**
  * Для детальных раздела доступно два режима работы, это когда курсор находится
  * на реквизите и существует непосредственно контрол реквизита и когда данными необходимо
  * оперировать напрямую меняя грид.
  * Этот миксин дополняет реквизиты детальных разделов таким образом, что конечная 
  * работа с реквизитом становится прозрачной и одинаково рабочей независимо от того,
  * есть ли сейчас контрол для реквизита или его нет.
  * Логика не вынесена в класс _details.BaseRequisite потому, что тогда для каждого
  * реквизита пришлось бы снова имплементировать существующие методы.
  * @mixin WebAccess.components.wrappers.form.requisites._details.editModeMixin
  * @propery {boolean} isEditMode признак наличия активного редактора
  * @private
  */

  var editModeMixin = {
    isEditMode: false,

    _grid: null,
    _filter: null,
    _filters: null,
    _isVisible: true,
    _pickValues: null,
    _references: null,
    _customAction: null,
    _mainReference: null,
    _lastReferences: null,
    _lastValue: null,
    _addLastObjectsPseudoReference: null,
    _bindReferenceGridDialog: null,
    _isChangeFired: false,

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    init: function (requisiteName, data, opt_parent, opt_grid) {

      var me = this;
      me._lastValue = {};
      me._super(requisiteName, data, opt_parent);
      me._isDisabled = data.isReadOnly;

      me._filters = {};
      me._references = {};
      me._pickValues = [];

      if (data.requisite) {
        me._references = data.requisite.refcodes;
      };

      me._grid = opt_grid; //Core.grid.details[me._parent._parentTable.name];
      me._bindGridEvents();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * В момент когда редактор активирован, необходимо перестроить jquery объекты на новые контролы;
    * @mixin WebAccess.components.wrappers.form.requisites._details.editModeMixin#_reInitControls
    * @return {WebAccess.components.wrappers.form.requisites._details.editModeMixin}
    */
    _reInitControls: function (editor) {
      this.controls = this._getControls(editor);
      this._bindEvents();
      this._isChangeFired = false;      
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**         
     * @see WebAccess.components.wrappers.form.requisites.BaseRequisite#_fireChange          
     * @private
     */
    _fireChange(reqFullName, value, displayValue, opt_ev) {      
      this._isChangeFired = true;
      this.touch();
      const requisiteData = {
        displayValue: displayValue,
        name: reqFullName, 
        value: value,         
      }
      this.fire('change', this, opt_ev, requisiteData);
    },

    /**    
     * @see WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_fireObjectSelectRequisiteChange          
     * @private
     */
    _fireObjectSelectRequisiteChange(jControl, event, requisiteData) {
      this._isChangeFired = true;
      this.touch();
      this.fire('change', jControl, event, requisiteData);
    },
       
    /**
    * 
    * @mixin WebAccess.components.wrappers.form.requisites._details.editModeMixin#_reInitControls
    * @return {WebAccess.components.wrappers.form.requisites._details.editModeMixin}
    */
    _bindGridEvents: function () {      
      var me = this;
      me._lastValue[me.name] = me.getValue();

      this._grid.bind('requisiteChange', (requisiteName, rowId, value, displayValue) => {
        // _isChangeFired устанавливается в True в _fireChange, в случае если изменение связанного с реквизитом контрола произошло раньше.
        if (!this._isChangeFired) {
          if (requisiteName === this.name && rowId === this._data.row_id) {
            let last = this._lastValue[this.name] || '';
            let current = value || '';

            if (last !== current) {           
              this._lastValue[this.name] = value;              
              this._fireChange(requisiteName, value, displayValue);
            }
          }
        }        
      });

      this._grid.bind('editorInit', function (requisiteName, rowId, value, displayValue, editor) {
        if (requisiteName === me.name && rowId == me._data.row_id) {
          me.isEditMode = true;

          if (me.isDisabled()) {
            editor.disable();
          } else {
            editor.enable();
          }

          if (me._filter) editor.setFilter(me._filter);
          if (!_.isEmpty(me._filters)) {
            for (var refName in me._filters) {
              editor.setFilters(me._filters[refName], refName);
            }
          }

          if (me._clearPick) {
            editor.clearValues();
          }

          if (!_.isEmpty(me._pickValues)) {
            _.each(me._pickValues, function (v) {
              editor.addValue(v[0], v[1], v[2]);
            });
          }

          if (!_.isEmpty(me._references)) {
            if (editor.setReferences) editor.setReferences(me._references);
          };

          if (me._mainReference) {
            if (editor.setReferences) editor.setMainReference(me._mainReference);
          };

          if (me._addLastObjectsPseudoReference) {
            editor.addLastObjectsPseudoReference(me._lastReferences);
          };

          if (me._bindReferenceGridDialog) {
            editor.bindReferenceGridDialog();
          }

          if (!_.isEmpty(me._customAction)) {
            editor.setCustomAction(me._customAction.callback, me._customAction.tooltip);
          };

          me._reInitControls(editor);

          me.fire('editModeChange', true);          
        }
      });

      this._grid.bind('editorDestroy', function () {
        // Оптимизация, что бы не срабатывало много editModeChange при кадом чихе.
        if (me.isEditMode) {
          me.isEditMode = false;
          me.fire('editModeChange', false);                  
        }
      });

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    _getControls: function (editor) {
      var me = this;
      if (editor) {
        var res = [];
        me.controlsIds = [];
        me.controlsIds.push(editor.id);
        res.push($('input#' + editor.id))
        this.controls = res;
        return res;
      } else {
        return this.controls;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    getValue: function () {
      var me = this;
      if (me.isEditMode) {
        return me._super();
      }
      var row = me._grid.dataView.getItemById(me._data.row_id);
      return row[me.name];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    getDisplayValue: function () {
      var me = this;
      if (me.isEditMode) {
        return me._super();
      }
      var row = me._grid.dataView.getItemById(me._data.row_id);
      return row[me._data.fieldName];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      var me = this;

      if (opt_displayValue && opt_displayValue[0] === '$') opt_displayValue = opt_displayValue.replace('$');
      opt_needTriggerResult = (opt_needTriggerResult !== false); //если не передан, то по умолчанию будет true.

      var editorActive = me._grid.grid.getEditorLock().isActive();

      if (me.isEditMode) {
        return me._super(value, opt_displayValue, opt_needTriggerResult);
      } else if (me.className == 'DetailDate') {
        if (value) {
          if (typeof value !== "object") {
            if (('' + value).indexOf('T') !== -1) {
              value = new window.Date(value);
            } else {
              value = parseDateTime(value);
            }
          }
          // Форматируем дату
          value = (this.isShowTime()) ? formatDateTime(value) : formatDate(value);
        } else {
          value = '';
        }
      }

      var row = me._grid.dataView.getItemById(me._data.row_id);
      row[me.name] = value;

      // тут нельзя проверять просто приводя к булеву, 
      // потому что 0 - тоже значение.
      if (!_.isUndefined(opt_displayValue)) {
        if (me.className == 'DetailInteger' && currentCultureName === 'ru-RU' && !_.isNull(opt_displayValue)) { //FIXME: Спецобработка
          opt_displayValue = ("" + opt_displayValue).replace('.', ',');
        }

        row[me._data.fieldName] = opt_displayValue;
      } else {
        row[me._data.fieldName] = value;
      }

      me._grid.dataView.updateItem(me._data.row_id, row);
      if (opt_needTriggerResult) {
        me._lastValue[me.name] = value;
        me._fireChange(me.fullName, value, opt_displayValue);
      }

      if (editorActive) me._grid.grid.editActiveCell();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
   * Сделать реквизит недоступным для изменения.
   *
   * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#disable
   * @since 5.0.0.7100
   * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Текущий объект реквизита.
   */
    disable: function () {
      var me = this;
      if (me.isEditMode) {
        me._super();
      }
      me._isDisabled = true;
      //Показываем визуально что реквизит в ячейке только для чтения
      const cellStyle = {
        [this.name]: 'readonly'
      };
      const rowNum = this._grid.dataView.getIdxById(this._data.row_id);      
      this._grid.grid.setCellCssStyles(`${rowNum}${this.name}`, {
        [rowNum]: cellStyle,
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сделать реквизит доступным для изменения.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#enable
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Текущий объект реквизита.
    * @since 5.0.0.7100
    */
    enable: function () {
      var me = this;
      if (me.isEditMode) {
        me._super();
      }
      me._isDisabled = false;
      const rowNum = this._grid.dataView.getIdxById(this._data.row_id);
      const cellStyle = {
        [this.name]: ''
      };
      this._grid.grid.setCellCssStyles(`${rowNum}${this.name}`, {
        [rowNum]: cellStyle,
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть реквизит и его подпись.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#hide
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Текущий объект реквизита.
    * @since 5.0.0.7100
    */
    hide: function () {
      log.warning('REQUISITE', 'This method was changed since version 5.2.0.1300 and may work improperly.');
      var me = this;
      me._isVisible = false;
      var cellStyle = {};
      var rownNum = me._grid.dataView.getIdxById(me._data.row_id);
      cellStyle[rownNum] = {};
      cellStyle[rownNum][me.name] = "hidden_cell";

      me._grid.grid.setCellCssStyles(rownNum + me.name, cellStyle);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Отобразить реквизит.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#show
    * @return {WebAccess.components.wrappers.form.requisites.BaseRequisite} Текущий объект реквизита.
    * @since 5.2.0.1300
    */
    show: function () {
      log.warning('REQUISITE', 'This method was changed since version 5.2.0.1300 and may work improperly.');
      var me = this;
      me._isVisible = true;
      var cellStyle = {};
      var rownNum = me._grid.dataView.getIdxById(me._data.row_id);
      cellStyle[rownNum] = {};
      cellStyle[rownNum][me.name] = "";
      me._grid.grid.setCellCssStyles(rownNum + me.name, cellStyle);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**   
    * Признак видимости реквизита на форме.
    *
    * @since 5.0.0.7100
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isVisible
    * @return {boolean} True – реквизит отображается на форме, иначе False.
    */
    isVisible: function () {
      log.warning('REQUISITE', 'This method was changed since version 5.2.0.1300 and may work improperly.');
      return this._isVisible;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
   * Признак недоступности реквизита для изменения.
   *
   * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isDisabled
   * @return {boolean} True – реквизит недоступен для изменения, иначе False.   
   * @since 5.2.0.1300
   */
    isDisabled: function () {
      var me = this;
      var isDisabled = false;
      return this._isDisabled;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить иконку к элементу управления реквизита, за исключением реквизитов типа «Справочник» и «Множественный выбор». 
    * Метод прикрепляет к тестовому полю действие для события, например, нажатие на иконку. 
    * При наступлении этого события в код передаются данные о текущем реквизите.
    *
    * @function WebAccess.components.wrappers.form.requisites.BaseRequisite#setCustomAction
    * @param {string} reqName Имя реквизита
    * @param {string} tooltip Подсказка к реквизиту
    * @param {function} callback Функция, которая будет вызвана после нажатия на иконку реквизита. 
    * В эту функцию первым параметром будет отправлена информация о реквизите.
    */
    setCustomAction: function (callback, opt_tooltip) {
      var me = this;
      me._customAction = {
        callback: callback,
        tooltip: opt_tooltip
      };

      if (me.isEditMode) {
        me._super(callback, opt_tooltip);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Подсветить реквизит
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#isRequired
    * @return {boolean} True – реквизит обязателен для заполнения, иначе False.
    * @param {integer} [opt_speed] скорость анимации
    * @param {string} [opt_color] цвет подсветки
    * @since 5.2.0.1300
    */
    highlight: function (opt_color, opt_speed) {
      var me = this;
      me._grid.dataView.flashCellById(me._data.row_id, me.name, opt_speed, opt_color);
      return me;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  global.WA.CMP.wrappers.form.requisites._details.editModeMixin = editModeMixin;
})(window);